import React, { useEffect, useState } from "react";
import { insightsApi } from "./api";
import { Breadcrumbs } from "../AdminLayout";
import { formatErr, tokenStore } from "../api";
import { toast, Toaster } from "sonner";
import { ShieldCheck, Check } from "lucide-react";
import { Link } from "react-router-dom";

const TYPE_TO_ROUTE = {
  conditions: "conditions", articles: "articles", guidelines: "guidelines",
  research_updates: "research-updates", evidence_summaries: "evidence-summaries"
};

export default function InsightsPending() {
  const [rows, setRows] = useState([]);
  const me = tokenStore.user;
  const canApprove = ["super_administrator","medical_reviewer"].includes(me?.role);

  const load = () => insightsApi.pending().then(setRows).catch(()=>{});
  useEffect(() => { load(); }, []);

  const approve = async (item) => {
    try { await insightsApi.approve(item.host_type === "research_updates" ? "research_updates" : item.host_type, item.host_id, item.insight.id); toast.success("Approved"); load(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="pending-approval">
      <Toaster richColors position="top-right"/>
      <Breadcrumbs items={["Admin", "Clinical Insights", "Pending Approval"]}/>
      <div className="mb-6">
        <h1 className="font-serif text-3xl text-navy tracking-tight">Clinical Insights · Pending Approval</h1>
        <p className="text-stone2 text-sm mt-1">Only Medical Reviewers and Super Administrators can approve public insights. All approvals are audit-logged.</p>
      </div>
      <div className="bg-white border border-line divide-y divide-line">
        {rows.map((r, i) => {
          const route = TYPE_TO_ROUTE[r.host_type];
          return (
            <div key={i} data-testid={`pa-${r.insight.id}`} className="p-5">
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0 flex-1">
                  <div className="mono text-[10px] uppercase tracking-widest text-stone2">{r.host_type.replace('_',' ')} · {r.host_title}</div>
                  <div className="flex items-center gap-2 mt-2 flex-wrap">
                    <div className="font-serif text-xl text-navy">{r.insight.title}</div>
                    <span className="mono text-[9px] uppercase tracking-widest px-1.5 py-0.5 bg-[#3F6250]/10 text-[#3F6250]">{r.insight.visibility}</span>
                  </div>
                  <div className="prose-article text-sm mt-3" dangerouslySetInnerHTML={{__html: (r.insight.body_markdown||"").replace(/\n/g,"<br>")}}/>
                </div>
                <div className="shrink-0 flex flex-col gap-2">
                  {route && <Link to={`/admin/content/${route}/${r.host_id}`} className="mono text-[10px] uppercase tracking-widest text-navy hover:text-terracotta">Open host →</Link>}
                  {canApprove && (
                    <button data-testid={`pa-approve-${r.insight.id}`} onClick={()=>approve(r)} className="mono text-[10px] uppercase tracking-widest bg-prestige text-white px-4 py-2 hover:bg-prestige/85 inline-flex items-center gap-1"><Check size={12}/> Approve</button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {rows.length === 0 && <div className="p-8 text-center text-stone2 flex flex-col items-center gap-2"><ShieldCheck size={20} className="text-prestige"/>Nothing awaiting approval.</div>}
      </div>
    </div>
  );
}
